/**
 * @fileoverview Utility functions for shadcn-vue components
 * @description Provides helper functions for class name manipulation and variants
 */

import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merges Tailwind CSS classes using clsx and tailwind-merge
 * @param {...(string|string[]|Object)} inputs - Class names to merge
 * @returns {string} Merged class names
 * @example
 * cn('text-red-500', 'bg-blue-500') // 'text-red-500 bg-blue-500'
 * cn('text-red-500', 'text-blue-500') // 'text-blue-500' (later class wins)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
